import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import doc_processing_icon from "../../../images/doc_processing_icon.png";
import Header from "../../Includes/Header";
import Footer from "../../Includes/Footer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store";

function EntityUnderReview() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const entityId = useSelector((state: RootState) => state.auth.entityId);
  const entityName = useSelector((state: RootState) => state.auth.entityName);

  const handleCheckAgain = () => {
    if (entityId) {
      navigate(`/onboarding?entityId=${encodeURIComponent(entityId)}`, { replace: true });
    } else {
      navigate("/onboarding", { replace: true });
    }
  };

  return (
    <>
      <Header />
      <Container fluid className="min-vh-custom">
        <br /><br /><br /><br />
        <Row className="mt-5">
          <Col md={12} className="text-center">
            <img src={doc_processing_icon} width={60} alt="doc icon" />
            <h3 className="text-center mt-3">{t('register.entity_pending_title')}</h3>
            <p className="text-secondary mt-3">
              {t('register.entity_pending_desc', {
                entityName: entityName || t('register.entity_pending_fallback_name'),
              })}
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-center">
            <Button className="btn btn-primary mt-3 rounded-5" onClick={handleCheckAgain}>
              {t('common.check_again')}
            </Button>
          </Col>
        </Row>
      </Container>
      <Footer full={true} />
    </>
  );
}

export default EntityUnderReview;
